/**
 * @Author: 36 Pixels <imac>
 * @Date:   06/04/2017, 3:37:39
 * @Email:  anais@36pixels.fr
 * @Project: First Pixel
 * @Filename: Menu.js
 * @Last modified by:   imac
 * @Last modified time: 04/04/2018, 6:03:15
 * @License: (c) 2017 by 36 Pixels. All Rights Reserved.
 */



var Accordion = require('./Accordion.js');
var scrollTo = require('../scroll/scrollToY.js');

var MenuResponsive = function (menu, button) {
    this.menu       = $(menu);
    this.shadow     = null;
    this.button     = $(button);
    this.status     = 0;
    this.mobileSize = 640;
    this.li         = this.menu.find('.menu > li');
    this.run();
};



MenuResponsive.prototype = {

    /**
     * opener
     * @return {[type]} [description]
     */
    run: function () {
        // this.shadow.on('click', this.doWoOpen.bind(this));
        this.creatShadow();

        // if (this.menu.hasClass('menu-with-accordion')) this.accordion();

        this.button.on('click', this.doWoOpen.bind(this));
    },


    /**
     * call the method if you want accordion
     * @return {[type]} [description]
     */
    accordion: function () {

        this.myAccordion = [];
        for (var i = this.li.length; i > 0; i--) {
            var current =  $( this.li.get(i) );
            var currentAccordion = new Accordion(current);
            currentAccordion.run();
            this.myAccordion.push(currentAccordion);
        }
        // for (var i = 0; i < this.li.length; i++) {
        //     var current =  $( this.li.get(i) );
        //     var currentAccordion = new Accordion(current);
        //     currentAccordion.run();
        //     this.myAccordion.push(currentAccordion);
        // }
    },

    /**
     * check if we open or not
     * @return {boolean}
     */
    doWoOpen: function (e) {
        e.preventDefault();
        return this.isOpen() ? this.closeMenu() : this.openMenu();
    },

    /**
     * check menu status
     * @return {boolean}
     */
    isOpen: function () {
        return this.status;
    },

    /**
     * [creatShadow description]
     * @return {[type]} [description]
     */
    creatShadow: function () {
        this.shadow = $('<div/>', {
            'class': 'dark-focus-responsive',
            click: this.doWoOpen.bind(this)
        }).appendTo(this.menu);
    },

    /**
     * open the menu
     * @return {[type]} [description]
     */
    openMenu: function () {
        scrollTo(0, null, null, function () {
            $('body').css('overflow', 'hidden');
        });
        this.status = 1;
        return this.menu.addClass('is-opened'),
            this.button.addClass('is-active');
    },

    /**
     * close the menu
     * @return {[type]} [description]
     */
    closeMenu: function () {
        $('body').css('overflow', '');
        this.status = 0;
        return this.menu.removeClass('is-opened'),
            this.button.removeClass('is-active');
    },

    /**
     * get client width
     * @return {[type]} [description]
     */
    getClientWidth: function () {
        return $(window).width();
    },

    /**
     *
     */
    isMobile: function () {
        return this.getClientWidth() <= this.mobileSize;
    },

};

module.exports = MenuResponsive;
